var moment = require('moment')

export const tssList = (activities) => {
    
    activities = Array.from(activities)
    const tss = activities.map(activity =>activity.stressScore)
    const dates = activities.map(activity =>activity.date)
    //console.log(tss,"lookhere")
    if (tss.length===0){
      //console.log(activities,"tssList is null?")
      return [[0,0,0,0],["1","2","3","4"]]
      
    }
    tss.push(0)
    dates.push(moment())
    return [tss,dates]
}

export const fitFatForm = (dates,tss) => {

var fitness = [0.00] 
var fatigue = [0.00] 
var form = [0.00] 

  for (var i=1;i<dates.length;i++){
    
    fitness[i]=fitness[i-1]+(tss[i]-fitness[i-1])*(1-Math.exp(-1/42))
    fatigue[i]=fatigue[i-1]+(tss[i]-fatigue[i-1])*(1-Math.exp(-1/7))
    form[i]=fitness[i-1]-fatigue[i-1]

  }
  return [fitness,fatigue,form]

}

export const trainingScoreCalc = (form,targetForm=10) =>{
  /// this index are calculated based that the training load loads 60 days more than today
  
  var form45Days = form.slice(-106,-60)
  var sum = 0
  var deviat = 0
  var filtered = 0

  for (var i=0;i<form45Days.length;i++){
      if (form45Days[i]<-1){
        sum += form45Days[i]
        filtered +=1
      }
      
  }
  var average = sum/filtered
  for (var i=0;i<form45Days.length;i++){
    if(form45Days[i]<-1){
      deviat = deviat + (form45Days[i]-average)**2
      console.log(deviat)
    }
  }
  deviat = (deviat/filtered)**(1/2)
  console.log(deviat)
  if (average > 0){
    return [0.00,0.00,0.00]
  }
  var averageAbs = Math.abs(average)
  var deviationFromTarget = Math.abs(averageAbs - targetForm)
  deviationFromTarget = deviationFromTarget/targetForm
  console.log(form45Days,form)
  console.log(averageAbs,filtered,targetForm,deviationFromTarget*10,deviat/2)
  const trainingScore =(10-deviationFromTarget*10 + (11-deviat))/2
  
  return[trainingScore,deviat,average]

}

export function averageProjected(form){
  var sum = 0
  var filtered = 0
    for (var i=0;i<form.length;i++){
      if (form[i]<-1){
        sum += form[i]
        filtered +=1
      }
      
  }
  var average = sum/filtered
  return average
}


export function trainingStatus(form){
  if (form<-25){
    return ['text-danger','critical status']
  }
  if (form<-20){
    return ['text-warning','overtraining']
  }
  if (form<-10){
    return ['text-success','optimal']
  }
  if (form<-5){
    return ['text-info','low optimal']
  }
  if (form<5){
    return ['text-warning','undertraining']
  }
  else{
    return ['text-info','race form']
  }
}
